import React, { useState, useRef, useEffect } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { MyDomain } from "../../App";

function ArrowBtn({ direction, onClick }) {
  const [hovered, setHovered] = useState(false);
  const [active, setActive] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => { setHovered(false); setActive(false); }}
      onMouseDown={() => setActive(true)}
      onMouseUp={() => setActive(false)}
      style={{
        flexShrink: 0,
        background: hovered ? "#e11d48" : "#ffffff",
        border: `1.5px solid ${hovered ? "#e11d48" : "rgba(0,0,0,0.13)"}`,
        borderRadius: "50%",
        width: 44,
        height: 44,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        color: hovered ? "white" : "#444",
        transform: `scale(${active ? 0.92 : 1})`,
        transition: "background 0.18s, border-color 0.18s, color 0.18s, box-shadow 0.18s, transform 0.12s",
        boxShadow: hovered ? "0 6px 20px rgba(225,29,72,0.22)" : "0 2px 10px rgba(0,0,0,0.11)",
        outline: "none",
      }}
    >
      {direction === "prev" ? <FiChevronLeft size={20} /> : <FiChevronRight size={20} />}
    </button>
  );
}

function BrandCircle({ brand }) {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`/brand/${brand.name.toLowerCase().replace(/\s+/g, "-")}`)}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 8,
        padding: "4px 6px",
        cursor: "pointer",
        width: 140,
        flexShrink: 0,
        boxSizing: "border-box",
      }}
    >
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "min(120px, 100%)",
          aspectRatio: "1",
          borderRadius: "50%",
          border: `1px solid ${hovered ? "#e11d48" : "rgba(0,0,0,0.08)"}`,
          background: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: hovered ? "0 8px 24px rgba(225,29,72,0.15)" : "0 2px 10px rgba(0,0,0,0.07)",
          transition: "all 0.25s",
          transform: hovered ? "translateY(-4px) scale(1.05)" : "translateY(0) scale(1)",
        }}
      >
        <img
          src={brand.logo}
          alt={brand.name}
          style={{ width: "70%", height: "70%", objectFit: "contain", display: "block" }}
        />
      </div>
      <span
        style={{
          fontSize: 12,
          fontWeight: 500,
          color: hovered ? "#e11d48" : "#555",
          transition: "color 0.2s",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        }}
      >
        {brand.name}
      </span>
    </div>
  );
}

export default function MPCompaniesCarousel() {
  const scrollRef = useRef(null);
  const drag = useRef({ down: false, startX: 0, scrollLeft: 0 });
  const [grabbing, setGrabbing] = useState(false);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    fetch(`${MyDomain}Brands/GetBrands`)
      .then((r) => r.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setBrands(
            data.map((b) => ({
              id: b.id,
              name: b.name,
              logo: `https://placehold.co/120x120/ffffff/333333?text=${encodeURIComponent(b.name)}`,
            }))
          );
        }
      })
      .catch(() => {});
  }, []);

  const onMouseDown = (e) => {
    drag.current = { down: true, startX: e.pageX, scrollLeft: scrollRef.current.scrollLeft };
    setGrabbing(true);
  };
  const onMouseMove = (e) => {
    if (!drag.current.down) return;
    scrollRef.current.scrollLeft = drag.current.scrollLeft - (e.pageX - drag.current.startX);
  };
  const onMouseUp = () => { drag.current.down = false; setGrabbing(false); };

  const scroll = (dir) => scrollRef.current?.scrollBy({ left: dir * 320, behavior: "smooth" });

  return (
    <div className="brands-section" style={{ padding: "40px 48px" }}>
      <div style={{ marginBottom: 28 }}>
        <h2 style={{ color: "#1a1a1a", fontSize: 22, fontWeight: 700, margin: 0, marginBottom: 6, letterSpacing: 0.3 }}>
          Our Brands
        </h2>
        <div style={{ width: 40, height: 3, background: "#e11d48", borderRadius: 2 }} />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <ArrowBtn direction="prev" onClick={() => scroll(-1)} />

        <div
          ref={scrollRef}
          className="brands-scroll"
          style={{
            flex: 1,
            overflowX: "auto",
            cursor: grabbing ? "grabbing" : "grab",
            userSelect: "none",
          }}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
        >
          <div style={{ display: "flex", paddingTop: 14, paddingBottom: 8 }}>
            {brands.map((brand) => (
              <BrandCircle key={brand.id} brand={brand} />
            ))}
          </div>
        </div>

        <ArrowBtn direction="next" onClick={() => scroll(1)} />
      </div>

      <style>{`
        .brands-scroll::-webkit-scrollbar { display: none; }
        .brands-scroll { scrollbar-width: none; -ms-overflow-style: none; }
        @media (max-width: 768px) { .brands-section { padding: 32px 20px !important; } }
        @media (max-width: 520px) { .brands-section { padding: 24px 12px !important; } }
      `}</style>
    </div>
  );
}
